"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toTitleCase = exports.isIrregularCapitalized = exports.isSpaceCharacter = exports.isAllCapitalized = exports.alwaysLowercaseWords = void 0;
var lodash_deburr_1 = __importDefault(require("lodash.deburr"));
var lodash_isnumber_1 = __importDefault(require("lodash.isnumber"));
var lodash_upperfirst_1 = __importDefault(require("lodash.upperfirst"));
/**
 * Extract only words from the string (excluding special characters. For example, $)
 *
 * Some examples
 *
 * Hello, world -> ["hello", "world"]
 * Musée Picasso -> ["Musée", "Picasso"]
 * Some name [Unique] -> ["Some", "name", "Unique"]
 * hang-up Gallery -> ["hang", "up", "Gallery"]
 * $Whatever space -> ["Whatever", "space"]
 */
var ONLY_WORDS_REGEX = /[^!@#\$%\^\&*\)\(+=.\-\s,\[\]\/\"\?]+/g;
exports.alwaysLowercaseWords = [
    "and",
    "or",
    "of",
    "but",
    "for",
    "or",
    "nor",
    "the",
    "a",
    "an",
    "as",
    "down",
    "under",
    "over",
    "to",
    "through",
    "during",
    "without",
    "on",
    "in",
    "by",
    "off",
];
var isAllCapitalized = function (word) {
    return word.toUpperCase() === word;
};
exports.isAllCapitalized = isAllCapitalized;
var isSpaceCharacter = function (word) {
    return /^\s$/.test(word);
};
exports.isSpaceCharacter = isSpaceCharacter;
/**
 * Checks for irregular capitalization
 *
 * Hello -> false
 * hello user -> false
 * HellO -> true
 * heLlo UsEr -> true
 */
var isIrregularCapitalized = function (word) {
    if (exports.isAllCapitalized(word)) {
        return false;
    }
    var restOfWord = word.slice(1);
    var convertedWord = lodash_deburr_1.default(restOfWord);
    return /[A-Z]+/.test(convertedWord);
};
exports.isIrregularCapitalized = isIrregularCapitalized;
var toTitleCase = function (text) {
    var words = text.match(ONLY_WORDS_REGEX);
    var counter = 0;
    if (words === null) {
        return text;
    }
    return text.replace(ONLY_WORDS_REGEX, function (word, index) {
        var lowercaseWord = word.toLowerCase();
        counter += 1;
        // Lowercase "x" in "Artsy X Capsule auctions" case
        if (lowercaseWord === "x" &&
            exports.isSpaceCharacter(text[index - 1]) &&
            exports.isSpaceCharacter(text[index + word.length])) {
            return lowercaseWord;
        }
        /**
         * We don't change:
         * - full capitalized words (maybe the brand name)
         * - irregular capitalization (heLlo UsEr)
         * - numbers
         */
        if (lodash_isnumber_1.default(word) ||
            exports.isAllCapitalized(word) ||
            exports.isIrregularCapitalized(word)) {
            return word;
        }
        // Capitalize the first and last words
        if (counter === 1 || counter === words.length) {
            return lodash_upperfirst_1.default(word);
        }
        if (exports.alwaysLowercaseWords.includes(lowercaseWord)) {
            return lowercaseWord;
        }
        return lodash_upperfirst_1.default(word);
    });
};
exports.toTitleCase = toTitleCase;
//# sourceMappingURL=index.js.map